import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import './leftNav.css'
import { withRouter } from 'react-router-dom'
import {getUnReadNum} from '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {getUnReadNum}
)
class LeftNav extends React.Component{
	constructor(props){
		super(props)
		this.state={
      		unRead:''
    	} 		
	}

	componentDidMount(){
    	
    	this.setState({
    		unRead:this.props.unRead
    	})
  	}
  	handleHref(i){
    	const arr=['/my-member','/my-welfare','/my-message']
    	
		this.props.history.push(arr[i])

  	}
  	render(){
  		const {children,myTitle,childData,optData} = this.props
  		
		return (
			<div className="left-nav">
				<div className="column-title">{myTitle}</div>
					{
						childData&&<ul className="detail" >
							{
								childData.map((item,i)=>{
									
									return <li key={i} className={optData[i]} onClick={()=>this.handleHref(i)}>
									{i==2?<div>{item}

										{this.props.unRead?<span className="my-message">{this.props.unRead}</span>:null}
									
									</div>:item}</li>
								})
							}
						</ul>
					}
					{

						children&&<ul className="detail">
							{children}
						</ul>
					}			
			</div>
		)
  	}
}

export default LeftNav


// WEBPACK FOOTER //
// ./src/component/left-nav/leftNav.js